var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationInvitation2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.1251H33.75C35.8219 13.1251 37.5 14.8032 37.5 16.8751V37.5001C37.5 39.5719 35.8219 41.2501 33.75 41.2501H11.25C9.17812 41.2501 7.5 39.5719 7.5 37.5001V13.2207C7.5 11.5651 8.58562 10.1063 10.17 9.63007L29.46 3.83257C30.6637 3.46882 31.875 4.37069 31.875 5.62694V13.1251",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7344 20.625C28.5113 20.625 30.375 23.07 30.375 25.3462C30.375 29.9662 22.6406 33.75 22.5 33.75C22.3594 33.75 14.625 29.9662 14.625 25.3462C14.625 23.07 16.4887 20.625 19.2656 20.625C20.8538 20.625 21.8963 21.3675 22.5 22.0275C23.1038 21.3675 24.1463 20.625 25.7344 20.625Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationInvitation2);
export default __webpack_public_path__ + "static/media/navigation-invitation2.28bf2c41.svg";
export { ForwardRef as ReactComponent };